module.exports = __webpack_public_path__ + "img/book.31c63c.svg";